export const userKeys = {
  all: ["user"] as const,
};
